import { iconLogoWordmark } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { Icon } from '../icon/icon.js';
export const SiteLogo = ({ appTitle, appTitleHref, className, href = '/', label, skipLink = 'Skip to main content', skipLinkTarget = 'main-content', ...rest }) => {
    const skipLinkHref = skipLinkTarget.startsWith('#') ? skipLinkTarget : `#${skipLinkTarget}`;
    return (React.createElement("h1", { className: cx('tds-site-logo', 'tds-align--start', className), ...rest },
        React.createElement("a", { "aria-label": "Tesla Logo", className: "tds-site-logo-link", href: href },
            React.createElement(Icon, { className: "tds-site-logo-icon", data: iconLogoWordmark }),
            label && React.createElement("span", { className: "tds--is_visually_hidden" }, label)),
        appTitle && (React.createElement("a", { className: "tds-app-title", href: appTitleHref },
            React.createElement("span", { className: "tds-app-title-text" }, appTitle))),
        React.createElement("a", { className: "tds-skip-to-content tds--is_visually_hidden", href: skipLinkHref, id: "top-of-page" }, skipLink)));
};
